export const EXCMRELATION_DELETE_RESET = 'EXCMRELATION_DELETE_RESET'
export const EXCMRELATION_DELETE_SET_ERROR = 'EXCMRELATION_DELETE_SET_ERROR'
export const EXCMRELATION_DELETE_SET_DELETED = 'EXCMRELATION_DELETE_SET_DELETED'
export const EXCMRELATION_DELETE_TOGGLE_LOADING = 'EXCMRELATION_DELETE_TOGGLE_LOADING'
